import { action, mutator } from "satcheljs";
import type { FlexPaneState } from "../store/store";
import { getStore } from "../store/store";
import { getDefaultFlexPaneWidth } from "../utils/getDefaultFlexPaneWidth";

export interface SetIsFlexPaneExpandedActionMessage {
    flexPaneId: string;
    isExpanded: boolean;
    expandedWidth: number | undefined;
}
export const setIsFlexPaneExpanded: (flexPaneId: string, isExpanded: boolean, expandedWidth?: number) => SetIsFlexPaneExpandedActionMessage = action("setIsFlexPaneExpanded", (flexPaneId: string, isExpanded: boolean, expandedWidth?: number): SetIsFlexPaneExpandedActionMessage => ({
    flexPaneId,
    isExpanded,
    expandedWidth,
}));

/**
 * Mutator to set the expanded state of a flex pane.
 * Saves to the FlexPaneState map to cache the expanded state for the scenario
 * where a user closes this pane and reopens it later.
 */
export const setIsFlexPaneExpandedMutator: (actionMessage: SetIsFlexPaneExpandedActionMessage) => void = mutator(setIsFlexPaneExpanded, actionMessage => {
    const flexPaneId = actionMessage.flexPaneId;
    let flexPaneState: FlexPaneState | undefined = getStore().flexPaneStateMap.get(flexPaneId);
    
    // Update FlexPaneState if it exists, otherwise create one
    if (flexPaneState) {
        flexPaneState.isExpanded = actionMessage.isExpanded;
        flexPaneState.expandedWidth =
            actionMessage.expandedWidth ?? getDefaultFlexPaneWidth(flexPaneId);
    }
    else {
        flexPaneState = {
            isShown: true, // Currently, must be opened pane in order to be expanded
            isExpanded: actionMessage.isExpanded,
            expandedWidth: actionMessage.expandedWidth ?? getDefaultFlexPaneWidth(flexPaneId),
        };
        getStore().flexPaneStateMap.set(flexPaneId, flexPaneState);
    }
    
    getStore().currentFlexPaneState = flexPaneState;
});
